import { Paragraph } from 'src/shared/ui/Paragraph';
import { Heading } from 'src/shared/ui/Heading';

export const SubmitForRating = () => {
	return (
		<>
			<Heading
				level={1}
				marginBottom="m"
			>
				Thank you for submitting your company information for ownership and performance evaluation.
			</Heading>

			<Paragraph>Data is currently being processed and undergoing quality controls prior to result becoming available.</Paragraph>

			<Paragraph>Please check the main landing page in 24 hours.</Paragraph>

			<Paragraph>If you have any updates or additional information in the future, feel free to edit or input new data and resubmit for updated documentation and results.</Paragraph>
		</>
	);
};
